import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import Menu from './screens/Menu';
import Product from './screens/Product';
import CreateProduct from './screens/CreateProduct';
import CreateMenuUhuu from './screens/CreateMenuUhuu';
import SelectProducts from './screens/SelectProducts';
import GlobalVariations from './screens/GlobalVariations';
import 'bootstrap/dist/css/bootstrap.css';
import './style/index.less';
import { PATHS } from './helpers/constants';


const Routes = () => (
  <Switch>
    <Route path={PATHS.menu} exact component={Menu} />
    <Route path={PATHS.createMenuUhuu} exact component={CreateMenuUhuu} />
    <Route path={PATHS.selectProducts} exact component={SelectProducts} />
    <Route path={PATHS.products} exact component={Product} />
    <Route path={PATHS.createProduct} exact component={CreateProduct} />
    <Route path={PATHS.editProduct} component={CreateProduct} />
    <Route path={PATHS.globalVariations} exact component={GlobalVariations} />
    <Route path="*" render={() => <Redirect to={PATHS.products} />} />
  </Switch>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/Routes.js